export const DEFAULT_PAGE_SIZE = 8;

export const DEFAULT_PAGE_INDEX = 1;
